import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { ECBasicOption } from 'echarts/types/dist/shared';
import {
    PieChart,
    GaugeChart,
    BarChart,
    HeatmapChart,
    LineChart,
    RadarChart,
} from 'echarts/charts';
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    VisualMapComponent,
} from 'echarts/components';
import VChart, { THEME_KEY } from 'vue-echarts';
import { nextTick, onBeforeUnmount, onMounted, PropType, provide, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiChart',
  props: {
    option: {
        type: Object as PropType<ECBasicOption>,
    },
    autoresize: {
        type: Boolean,
        default: true,
    },
    height: {
        type: String,
        default: '320px',
    },
},
  emits: ["mouseover", "mouseout", "click"],
  setup(__props, { emit: __emit }) {

use([
    CanvasRenderer,
    PieChart,
    BarChart,
    GaugeChart,
    HeatmapChart,
    LineChart,
    RadarChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    VisualMapComponent,
]);

provide(THEME_KEY, 'light');

const props = __props;

const emit = __emit;

const containerRef = ref<HTMLElement | null>(null);
const isReady = ref(false);
let resizeObserver: ResizeObserver | null = null;
let animationFrame: number | null = null;

const scheduleReadinessCheck = () => {
    if (animationFrame !== null) return;

    animationFrame = window.requestAnimationFrame(() => {
        animationFrame = null;
        const container = containerRef.value;
        if (!container) return;

        const isVisible = container.clientWidth > 0 && container.clientHeight > 0;
        if (!isVisible) return;

        isReady.value = true;
        resizeObserver?.disconnect();
        resizeObserver = null;
    });
};

onMounted(async () => {
    await nextTick();
    resizeObserver = new ResizeObserver(scheduleReadinessCheck);
    if (containerRef.value) resizeObserver.observe(containerRef.value);
    scheduleReadinessCheck();
});

onBeforeUnmount(() => {
    resizeObserver?.disconnect();
    if (animationFrame !== null) window.cancelAnimationFrame(animationFrame);
});

return (_ctx: any,_cache: any) => {
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createBlock(_component_UiPanel, {
    class: "w-full",
    "no-padding": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "containerRef",
        ref: containerRef,
        class: "w-full",
        style: _normalizeStyle({ height: props.height })
      }, [
        (isReady.value)
          ? (_openBlock(), _createBlock(_unref(VChart), {
              key: 0,
              class: "h-full w-full",
              option: props.option,
              autoresize: props.autoresize,
              "update-options": { notMerge: true },
              onMouseover: _cache[0] || (_cache[0] = ($event: any) => (emit('mouseover', $event))),
              onMouseout: _cache[1] || (_cache[1] = ($event: any) => (emit('mouseout', $event))),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('click', $event)))
            }, null, 8, ["option", "autoresize"]))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _: 1
  }))
}
}

})